import { render, staticRenderFns } from "./NavMenuItems.vue?vue&type=template&id=2f005d9b&"
import script from "./NavMenuItems.vue?vue&type=script&lang=js&"
export * from "./NavMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports